module.exports = __webpack_public_path__ + "static/media/caiway_logo.289abfe5.png";